export * from './new-colaborador-dialog.component';



// WEBPACK FOOTER //
// E:/jenkins_home/workspace/_agenda-unco-front-legacy_master/frontend-web/src/app/components/colaboradores/new-colaborador-dialog/index.ts